module.exports = __webpack_public_path__ + "static/media/CLC_cover_03.d6c2edbd.jpg";